import type { ReactNode } from 'react';
import { PageShareButton } from './PageShareButton';

interface PageHeaderProps {
  children: ReactNode;
  adornment?: ReactNode;
  actions?: ReactNode;
  showShareButton?: boolean;
}

export function PageHeader({
  children,
  adornment,
  actions,
  showShareButton = true,
}: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2">
        <h1 className="font-inter-tight min-w-0 text-3xl font-semibold text-neutral-900">
          {children}
        </h1>
        {adornment ? <div className="flex flex-wrap items-center gap-2">{adornment}</div> : null}
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {actions}
        {showShareButton ? <PageShareButton /> : null}
      </div>
    </div>
  );
}
